import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { ACCOUNT_TYPE } from 'containers/Account/accountSlice'
import { useHistory, useParams } from 'react-router-dom'
import Sections from 'containers/Account/Sections'
import useTranslation from 'hooks/useTranslation'
import Popups from 'containers/Account/Popups'
import { useSelector } from 'react-redux'
import { useLayoutEffect } from 'react'
import './style.scss'

const Account = () => {
  const isLogin = useSelector(selectIsLoggedIn)
  const isLoading = useSelector(selectIsLoading)
  const { key } = useParams()

  const { push, replace } = useHistory()
  const { t } = useTranslation('account')
  const goTo = route => { push(`/account/${route}`) }

  useLayoutEffect(() => {
    if (!isLogin && !isLoading && key !== ACCOUNT_TYPE.settings) replace('/login')
  }, [isLoading, isLogin, key, replace])

  return (
    <>
      <div className='desktopAccount account'>
        <div className='title left'>
          <div>{t('customerPanel')}</div>
          <div className='group'>
            <span>{t('subTitle')}</span>
          </div>
        </div>
        <div className="desktopAccount__wrap">
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.basic)}>
            <i className="icon s32 icon--user"></i>
            <span>{t('basic')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.company)}>
            <i className="icon s32 icon--company"></i>
            <span>{t('companies')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.invoices)}>
            <i className="icon s32 icon--invoices"></i>
            <span>{t('invoices')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.share)}>
            <i className="icon s32 icon--share"></i>
            <span>{t('shares')}</span>
          </div>
          <div className="item" onClick={() => goTo(ACCOUNT_TYPE.payments)}>
            <i className="icon s32 icon--payments"></i>
            <span>{t('payments')}</span>
          </div>

        </div>
        <Sections />
        <Popups />
      </div>
    </>
  )
}

export default Account